import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { FirebaseOtpService } from '../../services/firebase-otp.service';
import { ToastService } from 'src/app/util/toast.service';
import { LoaderService } from 'src/app/util/loader.service';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})
export class OtpVerificationComponent implements OnInit, OnDestroy {
  @Input() phoneNumber: string = '';
  @Input() name: string = '';
  @Output() verificationComplete = new EventEmitter<any>();
  @Output() resendOTP = new EventEmitter<void>();

  otpCode: string = '';
  isLoading: boolean = false;
  countdown: number = 60;
  canResend: boolean = false;
  private countdownInterval: any;

  constructor(
    private firebaseOtpService: FirebaseOtpService, private toast: ToastService,
    private loader: LoaderService,
  ) { }

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startCountdown() {
    this.canResend = false;
    this.countdown = 60;
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.canResend = true;
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  onOtpChange() {
    if (this.otpCode.length === 6 && !this.isLoading) {
      this.verifyOTP();
    }
  }

  async verifyOTP() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.loader.show();
    try {
      const user = await this.firebaseOtpService.verifyOTP(this.otpCode, {
        name: this.name
      });
      this.loader.hide();
      this.isLoading = false;
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      this.verificationComplete.emit(user);
    } catch (error: any) {
      this.loader.hide();
      this.isLoading = false;
      console.error('Error verifying OTP:', error);

      let errorMessage = 'Invalid OTP. Please try again.';

      if (error.code === 'auth/invalid-verification-code') {
        errorMessage = 'Invalid OTP code. Please check and try again.';
      } else if (error.code === 'auth/code-expired') {
        errorMessage = 'OTP has expired. Please request a new one.';
      } else if (error.message && error.message.includes('confirmation result')) {
        errorMessage = 'Session expired. Please request OTP again.';
      } else if (error.code) {
        errorMessage = `Error: ${error.code}`;
      }

      this.toast.error(errorMessage);
      this.otpCode = '';
    }
  }

  async resendCode() {
    this.resendOTP.emit();
    this.startCountdown();
  }

  getMaskedPhoneNumber(): string {
    if (this.phoneNumber.length > 4) {
      const lastFour = this.phoneNumber.slice(-4);
      const masked = '*'.repeat(this.phoneNumber.length - 4);
      return masked + lastFour;
    }
    return this.phoneNumber;
  }
}